export const BADGE_MODAL_FADE_DURATION = 200;
